import React, { useState, useEffect, useRef } from 'react';
import classes from './MisData.module.css';
import Navbar from '../Components/Navbar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { misData } from '../Services/Apis';
import axios from 'axios';
import { Calendar } from 'primereact/calendar';

const MisData = () => {
    const [data, setData] = useState([]);
    const [date, setDate] = useState(new Date());

    // Ref for PrimeReact Calendar
    const calendarRef = useRef(null);

    const getMisdata = async () => {
        // console.log(date);
        const formattedDate = new Date(date).toLocaleDateString('en-CA');
        // console.log(formattedDate);

        try {
            const res = await axios.get(`${misData}?date=${formattedDate}`);
            // console.log(res);
            setData([res.data]);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getMisdata();
    }, [date]);

    // Function to show the calendar popup on icon click
    const handleCalendarIconClick = () => {
        if (calendarRef.current) {
            calendarRef.current.show();  // Open the Calendar popup
        }
    };

    return (
        <div className={classes.container}>
            <Navbar />
            <div className={classes.main}>
                <p className={classes.title}>Mis Data of {new Date(date).toLocaleDateString('en-CA')}</p>

                <div className={classes.input_div}>
                    {/* Assign ref to Calendar component */}
                    <Calendar 
                        ref={calendarRef} 
                        value={date} 
                        maxDate={new Date()} 
                        onChange={(e) => setDate(e.value)} 
                        dateFormat="dd/mm/yy" 
                        className={classes.input} 
                         // This will also add a default calendar icon
                    />
                    
                    {/* Custom icon to trigger calendar */}
                    <i 
                        className="pi pi-calendar-clock" 
                        onClick={handleCalendarIconClick} 
                        style={{ cursor: 'pointer', marginLeft: '10px' }}
                    ></i>
                </div>

                <DataTable value={data} showGridlines tableStyle={{ minWidth: '50rem' }} className="w-full custom-table rounded-md text-center">
                    <Column field="sub" header="SUB" alignHeader="center" headerClassName="bg-gray-300"></Column>
                    <Column field="callback" header="CALLBACK" headerClassName="bg-gray-300"></Column>
                    <Column field="sms" header="SMS" headerClassName="bg-gray-300"></Column>
                    <Column field="renrev" header="REN REVENUE" headerClassName="bg-gray-300"></Column>
                    <Column field="renewal" header="RENEWALS" headerClassName="bg-gray-300"></Column>
                    <Column field="unsub" header="UNSUB" headerClassName="bg-gray-300"></Column>
                    <Column field="wap" header="WAP" headerClassName="bg-gray-300"></Column>
                    <Column field="subrev" header="SUB REVENUE" headerClassName="bg-gray-300"></Column>
                </DataTable>
            </div>
        </div>
    );
};

export default MisData;
